import styled from 'styled-components'
import {
	ButtonZoneWrapper,
	DropzoneStyled,
	FileError,
	FileWrapperItem,
} from 'LibNeo/components/Basic/Upload/styled'

export const BgUploadWrapper = styled.div`
	${ButtonZoneWrapper} {
		display: block;
		${FileError} {
			margin: 4px 0 0 0;
		}
	}
	${FileWrapperItem} {
		margin: 0;
	}

	${DropzoneStyled} {
		display: flex;
		flex-direction: column;
		padding-left: 4px;
		border-radius: 6px;
		width: calc(100% - 30px);
		max-width: 400px;

		cursor: inherit;
		pointer-events: inherit;
	}
`

export const BgUploadDisabledWrapper = styled.div`
	pointer-events: none;
`
